/* @flow */

import React from 'react';
import { Segment } from 'semantic-ui-react';

type Props = {
  users: Array<TargetUser>,
};

const TargetUsersCounter = ({ users }: Props) => {
  const count = users.length;

  return (
    <Segment>
      <div className="header">
        Destinataires:
        <em> {count} sélectionné(s)</em>
      </div>
    </Segment>
  );
};

export default TargetUsersCounter;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/TargetUsersCounter.js